export default "__VITE_ASSET__3KaUwg$0__"